export function formatData(startDate, divider = '-') {
  var data = new Date(startDate);
  var dia = String(data.getDate()).padStart(2, "0");
  var mes = String(data.getMonth() + 1).padStart(2, "0");
  var ano = data.getFullYear();
  var dataAtual = dia + divider + mes + divider + ano;
  return dataAtual;
}

// converte data vinda do Firestore em Date: aceita o Timestamp serializado
// ({_seconds,_nanoseconds}) devolvido pelas Cloud Functions e a string ISO das versões anteriores
export function parseFirestoreDate(value) {
  if (!value) return null;

  const seconds = value._seconds ?? value.seconds;
  const nanoseconds = value._nanoseconds ?? value.nanoseconds ?? 0;

  // trunca os nanossegundos como o Timestamp.toDate() do Firestore faz
  const date =
    typeof seconds === "number"
      ? new Date(seconds * 1000 + Math.floor(nanoseconds / 1000000))
      : new Date(value);

  return isNaN(date.getTime()) ? null : date;
}

export function formatDateTime(startDate, divider = '-') {
  const data = new Date(startDate);

  const dia = String(data.getDate()).padStart(2, "0");
  const mes = String(data.getMonth() + 1).padStart(2, "0");
  const ano = data.getFullYear();

  const horas = String(data.getHours()).padStart(2, "0");
  const minutos = String(data.getMinutes()).padStart(2, "0");

  return `${dia}${divider}${mes}${divider}${ano} ${horas}:${minutos}`;
}
